import { generateCustomEndpoint } from "@/utils/utils";
import type { PaginatedResponse } from "@/v2/queries/types";
import { apiClientJSON } from "../apiClient";

export interface InternalUser {
  email: string;
  cityId: number | null;
  cityName: string | null;
  whiteLabelId: number | null;
  whiteLabelCode: string | null;
  status: string;
  userType: string;
}

export interface InternalUserCreate {
  email: string;
  password: string;
  cityId?: number | null;
  whiteLabelId?: number | null;
  userType: string;
}

export interface InternalUserUpdate {
  cityId?: number | null;
  whiteLabelId?: number | null;
  status?: string;
  userType?: string;
}

export interface ManagedUserListParams {
  page?: number;
  search?: string;
  cityId?: string;
  sort?: string;
  filter?: string;
  size?: number;
}

export const getAllManagedUser = (
  params: ManagedUserListParams = {}
): Promise<PaginatedResponse<InternalUser>> => {
  const {
    page = 0,
    search = "",
    cityId = "",
    sort = "",
    filter = "",
    size = 10,
  } = params;
  const endpoint = generateCustomEndpoint(
    "/account-service/dashboard/internal-user?",
    page,
    search,
    cityId,
    sort,
    filter,
    String(size)
  );
  return apiClientJSON.get(endpoint).then((r) => r.data);
};

export const createInternalUser = (
  dto: InternalUserCreate
): Promise<InternalUser> => {
  return apiClientJSON
    .post("/account-service/dashboard/internal-user", dto)
    .then((r) => r.data);
};

export const updateInternalUser = (
  email: string,
  dto: InternalUserUpdate
): Promise<InternalUser> => {
  return apiClientJSON
    .put(`/account-service/dashboard/internal-user/${email}`, dto)
    .then((r) => r.data);
};

export const deleteInternalUser = (email: string): Promise<void> => {
  return apiClientJSON
    .delete(`/account-service/dashboard/internal-user/${email}`)
    .then(() => {});
};

export const getInternalUser = (email: string): Promise<InternalUser> => {
  return apiClientJSON
    .get(`/account-service/dashboard/internal-user/${email}`)
    .then((r) => r.data);
};
